import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";

import SideMenuContext from "../common/context/sideMenuContext.js";
import { AuthProvider, useAuth } from "./contexts/AuthContext.js";

import { loadImage } from "../common/services/uiService.jsx";

import Home from "./components/home.jsx";
import NavBar from "./components/navbar.jsx";
import Login from "./components/Login.jsx";

import OfflineForm from "../common/components/forms/offlineForm.jsx";
import ErrorPopupForm from "../common/components/forms/errorPopupForm.jsx";

import "./../App.css";
import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { configureApiClient, setAuthContextRef } from "./services/apiClient.js";
import "./App.css";
// Wrapper component to connect auth context to API client
const AuthConnector = ({ children }) => {
  const authContext = useAuth();

  React.useEffect(() => {
    // Connect the auth context to the API client
    setAuthContextRef(authContext);
  }, [authContext]);

  return children;
};

class AdminUtilitiesApp extends Component {
  showError = "ShowError";
  NotShowError = "NotShowError";

  state = {
    isListOpen: false,
    menues: [],
    errorTitle: "",
    errorMessage: "",
    errorLinkTo: "",
    errorLinkTitle: "",
    errorLinkClassName: "",
    windowCmd: "",
    show: this.NotShowError,
    isOffline: false,
  };

  constructor(props) {
    super(props);
    this.toggleList = this.toggleList.bind(this);
  }

  updateErrorMessage = (
    title,
    message,
    linkTo = "",
    linkTitle = "",
    linkClass = "",
    cmd = ""
  ) => {
    console.log("Error=" + title + ",,," + message);
    this.setState({
      errorTitle: title,
      errorMessage: message,
      errorLinkTo: linkTo,
      errorLinkTitle: linkTitle,
      errorLinkClassName: linkClass,
      windowCmd: cmd,
    });
  };

  getPermissionsMenu = () => {
    return {
      menues: [
        {
          id: "Home",
          Title: "Admin Utilities",
          to: "/home",
          objectName: "Home",
          img: "Home.svg",
          activeImg: "HomeActive.svg",
          nonActiveImg: "Home.svg",
          beforeTitle: "",
          beforeTitleClass: "",
          beforeSpace: "1",
          beforeSpaceClass: "BeforeHomeSpace",
          regClassName: "SideMenuLink nav-item",
          activeClassName: "SideMenuLink HomeMenuActive nav-item active",
          regTitleClassName: "sideMenuTitle",
          activeTitleClassName: "sideMenuTitle HomeMenuTitleActive",
        },
      ],
    };
  };

  handleSideMenu = () => {
    try {
      const result = this.getPermissionsMenu();
      this.setState({ menues: result.menues });
    } catch (ex) {
      console.log("Menues error:", ex);
    }
  };

  toggleList = (event) => {
    event.stopPropagation();
    this.setState((prevState) => ({
      isListOpen: !prevState.isListOpen,
    }));
  };

  componentDidMount() {
    if (this.props.apiEndPoint) {
      configureApiClient(this.props.apiEndPoint);
    }
    this.handleSideMenu();
  }

  checkOfflineStatus = () => {
    const nigeriaTime = new Date().toLocaleString("en-US", {
      timeZone: "Africa/Lagos",
    });
    const currentHour = new Date(nigeriaTime).getHours();
    const isOffline = currentHour >= 21 && currentHour < 2;
    this.setState({ isOffline });
  };

  handleCloseLogin = () => {
    // Handle login form close if needed
  };

  render() {
    const logo1 = loadImage("logo_Anambra.png");
    const { isOffline } = this.state;

    if (isOffline) {
      return <OfflineForm />;
    }

    return (
      <AuthProvider applicationName={this.props.applicationName}>
        <AuthConnector>
          <SideMenuContext.Provider
            value={{
              menues: this.state.menues,
              onHandleSideMenu: this.handleSideMenu,
            }}
          >
            <React.Fragment>
              <div className="inlineDiv">
                <div id="logoDiv">
                  <a href="https://www.mol.anambrastate.gov.ng/">
                    <img
                      src={logo1}
                      className="logo_Zambia"
                      srcSet={`${logo1} 1x, ${logo1} 2x, ${logo1} 3x`}
                      alt=""
                    />
                  </a>
                  <span className="Republic-of-Zambia">
                    Anambra State Government
                  </span>
                </div>

                <div id="mainNavBar">
                  <NavBar />
                </div>

                <nav
                  id="rightMenu"
                  className="navbar navbar-expand-lg navbar-light"
                >
                  <button
                    id="MenuBtn"
                    className="navbar-toggler"
                    onClick={this.toggleList}
                  >
                    {this.state.isListOpen ? (
                      <span className="fas fa-times"></span>
                    ) : (
                      <span className="navbar-toggler-icon"></span>
                    )}
                  </button>
                </nav>
              </div>

              <main id="main">
                <Switch>
                  <Route
                    path="/login"
                    render={() => (
                      <Login
                        closeLoginForm={this.handleCloseLogin}
                        applicationName={this.props.applicationName}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/home"
                    render={(props) => (
                      <Home
                        {...props}
                        generalEndPoint={this.props.generalEndPoint}
                        usersEndPoint={this.props.usersEndPoint}
                      />
                    )}
                  />
                  <Redirect from="/" exact to="/home" />
                  <Redirect to="/not-found" />
                </Switch>

                {this.state.show === this.showError && (
                  <div>
                    <ErrorPopupForm
                      errorTitle={this.state.errorTitle}
                      errorMessage={this.state.errorMessage}
                      errorLinkTo={this.state.errorLinkTo}
                      errorLinkTitle={this.state.errorLinkTitle}
                      errorLinkClassName={this.state.errorLinkClassName}
                      windowCmd={this.state.windowCmd}
                    />
                  </div>
                )}
              </main>
            </React.Fragment>
          </SideMenuContext.Provider>
        </AuthConnector>
      </AuthProvider>
    );
  }
}

export default AdminUtilitiesApp;
